(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["soapyard-card-order"] && !Shopify.designMode) return;
  try {
    class SoapyardCardOrder extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('[data-card-format]')?.addEventListener('change', (event) => {
        const option = event.target.selectedOptions[0];
        if (!option) return;
        this.querySelector('input[name="id"]').value = option.value;
        this.querySelector('[data-card-price]').textContent = option.dataset.price;
        const quantity = this.querySelector('input[name="quantity"]');
        const selector = this.querySelector('quantity-selector-component');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        quantity.value = quantity.min;
        quantity.dataset.min = quantity.min;
        quantity.dataset.cartQuantity = '0';
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        if (selector) selector.dataset.variantId = option.value;
        this.querySelector('[ref="addToCartTextError"]')?.classList.add('hidden');
      });
    }
  }
  if (!customElements.get('soapyard-card-order')) customElements.define('soapyard-card-order', SoapyardCardOrder);
  } catch(e) { console.error(e); }
})();

})();
